module.exports = __webpack_public_path__ + "static/media/Jason_C.4ad54955.png";